import { Redirect, Route, Switch } from "react-router";
import { EntitiesScreen } from "../pages/superAdmin/EntitiesScreen";
import CloneForm from "../utils/clone/form/CloneForm";

export const SuperAdminDashboarRouter = () => {
  return (
    <div>
      <Switch>
        <Route path="/super/dashboard/entity" component={EntitiesScreen} />
        <Route path="/super/dashboard/clone" component={CloneForm} />
        <Redirect to="/super/dashboard/entity" />
      </Switch>
    </div>
  );
};
